<p [id]="id" class="warning">
  <xpo-icon iconName="info"></xpo-icon>{{message}}
</p>
